import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import DomainEditDialogHeader from './DomainViewDialogHeader';
import api from '@/utils/apiClient';
import { DomainViewBasicDetails } from './DomainViewBasicDetails';
import { DomainViewTabs } from './DomainViewTabs';
import LoadingIcon from 'mdi-react/LoadingIcon';

const DomainViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: 'View Domain',
    hide: onHide,
  });

  const [state, setState] = React.useState({
    loading: false,
    domain: {},
    error: '',
  });

  React.useEffect(() => {
    if (id) getDomainById(+id);
  }, [id]);

  const getDomainById = async (domainId) => {
    try {
      setState({ ...state, loading: true });
      const { data: res, isSuccess } = await api.domain.getDomainById(domainId);
      if (isSuccess) {
        setState({ ...state, loading: false, domain: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting domain details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, domain: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, domain } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <DomainEditDialogHeader modal={modal} domain={domain} />
      {/*Domain Modal Body*/}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting domain details...' : error}
            </div>
          </>
        ) : (
          <>
            <DomainViewBasicDetails domain={domain} />
            <DomainViewTabs domain={domain} />
          </>
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(DomainViewDialog);
